import React, { useState, useEffect } from "react";
import {
  Upload,
  Button,
  Form,
  Select,
  Row,
  Drawer,
  Tabs,
  Col,
  Input,
  DatePicker,
} from "antd";
import { CalendarOutlined, CloseCircleFilled } from "@ant-design/icons";
import UserImage from "../../assets/images/user-image.png";
import RightIcon from "../../assets/images/right-icon-errow.svg";
import NoSearchAssistant from "../../assets/images/research-no-items.svg";
import DescriptionEditor from "../../components/DescriptionEditor";
import TextArea from "antd/lib/input/TextArea";
import UploadIcon from "../../assets/images/upload-icon.svg";
import { Severty, ShowToast } from "../../helper/toast";
import useDraftAutosave from "../../hooks/useDraftAutosave";
import useRequest from "../../hooks/useRequest";
import { useParams } from "react-router-dom";
import Select01 from "react-select";
import moment from "moment";
const { Option } = Select;
const { TabPane } = Tabs;

const CreateNewPostIndex = ({ open, onClose }) => {
  const [uploadedImage, setUploadedImage] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [pillar, setPillar] = useState([]);
  const [content, setContent] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const { request } = useRequest();
  // Central store for all tab data
  const [allFormData, setAllFormData] = useState({});
  const [loading,setLoading] = useState(false);
  const { id } = useParams();

  // Autosave the composed text so closing the tab mid-compose doesn't lose it.
  // This writes to the writing-assistant draft store rather than creating a
  // Post: addPost() has no update path, so an autosaving wizard would leave a
  // trail of half-configured posts in the client's list. Only kicks in once
  // there's actual generated content — an empty wizard saves nothing.
  const { scheduleSave } = useDraftAutosave({
    enabled: !!content && !!String(content).trim() && !!id,
    getPayload: () => {
      const t1 = allFormData.tab1 || {};
      return {
        title: t1.topic || "Untitled Post",
        content,
        platform: t1.platform,
        location: t1.location,
        tone: t1.tone,
        words: t1.words,
        wordcount: t1.wordcount,
        age: t1.age,
        status: "draft",
        userId: id,
      };
    },
    createUrl: "/admin/access-module/writing-assistance/add",
    updateUrl: (draftId) => `/admin/access-module/writing-assistance/draft/${draftId}`,
  });

  useEffect(() => {
    scheduleSave();
  }, [content, scheduleSave]);
  // One form instance per tab:
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [form4] = Form.useForm();

  const inputOptions = [
    { value: "design", label: "Design" },
    { value: "development", label: "Development" },
    { value: "testing", label: "Testing" },
  ];
  const getPrompt = (values) => {
    return `Write a ${values?.topic} for the ${
      values?.platform
    } platform in a ${values?.tone} tone using ${
      values?.words
    } words style, targeting an audience in ${
      values?.location
    }. The target age group is ${
      values?.age || "any"
    }, and it should be around ${values?.wordcount} words in length.`;
  };

  const fetchPillars = () => {
    request({
      url: `/admin/access-module/content/${id}?limit=10000`,
      method: "GET",
      onSuccess: (data) => {
        if (data.status === 200) {
          setPillar(data.data.themes);
        } else {
        }
      },
    });
  };
  const getContentFromLocal = (prompt) => {
    return new Promise((resolve, reject) => {
      request({
        url: "/user/writing-assitance/get-content?prompt=" + prompt,
        method: "GET",
        data: prompt,
        onSuccess: (data) => {
          if (data.status === 200) {
            resolve(data.data.content.content);
          } else {
            resolve(null);
          }
        },
        onError: () => reject(new Error("Error fetching local content")),
      });
    });
  };

  const fetchDeepSeekContent = async (prompt) => {
    const response = await fetch(
      "https://api.deepseek.com/v1/chat/completions",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer sk-cd974b3ab9e649cfaa2a135fb42e6e04`,
        },
        body: JSON.stringify({
          model: "deepseek-chat",
          messages: [{ role: "user", content: prompt }],
        }),
      }
    );
    const data = await response.json();
    return data.choices?.[0]?.message?.content || "No content generated.";
  };

  const saveContentToLocal = (prompt, generatedText) => {
    return new Promise((resolve, reject) => {
      request({
        url: "/user/writing-assitance/add-content",
        method: "POST",
        data: { prompt, generatedText },
        onSuccess: (data) => {
          if (data.status === 200) {
            resolve(data.data.content);
          } else {
            resolve(null);
          }
        },
        onError: () => reject(new Error("Error saving content")),
      });
    });
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #ccc",
      boxShadow: "none",
      minHeight: "40px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#e6f7ff" : "#fff",
      color: "#000",
    }),
  };
  const handleFinish = async (formInstance) => {
    console.log("formInsatnce", formInstance);
    const values = await formInstance.validateFields();
    const prompt = getPrompt(values);
    let isCall = true;
    setLoading(true);
    try {
      try {
        const localContent = await getContentFromLocal(prompt);
        if (localContent) {
          setContent(localContent);
          isCall = false;
        }
      } catch (error) {}

      if (isCall) {
        const generatedText = await fetchDeepSeekContent(prompt);
        console.log("DeepSeek response:", generatedText);

        try {
          const savedContent = await saveContentToLocal(prompt, generatedText);
          if (savedContent) {
            setContent(savedContent);
            isCall = false;
          }
        } catch (error) {
          ShowToast(`Error creating content`, Severty.ERROR);
        }

        setContent(generatedText);
        ShowToast("Content generated successfully!", Severty.SUCCESS);
      }
    } catch (error) {
      console.error("Error:", error);
      ShowToast("Error generating content.", Severty.ERROR);
    } finally {
      setLoading(false);
    }
  };
  const removeOption = (valueToRemove) => {
    const filtered = selectedOptions.filter(
      (opt) => opt.value !== valueToRemove
    );
    setSelectedOptions(filtered);
  };

  const handleChange = (selected) => {
    // Always ensure selectedOptions is an array
    setSelectedOptions(Array.isArray(selected) ? selected : []);
  };

  useEffect(() => {
    fetchPillars();
  }, []);

  const handleNext = async (formInstance, tabKey) => {
    try {
      const values = await formInstance.validateFields();
      console.log(
        values,
        ">?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?>?"
      );
      setAllFormData((prev) => ({
        ...prev,
        [tabKey]: values,
      }));
      console.log("Saved so far:", { ...allFormData, [tabKey]: values });

      const currentTabNumber = Number(activeTab);
      const nextTabNumber = currentTabNumber + 1;
      if (nextTabNumber <= 4) {
        setActiveTab(String(nextTabNumber));
      } else {
        await addPost();
      }
    } catch (err) {
      console.log("Validation failed", err);
    }
  };

  const addPost = async () => {
    const payload = {
      ...allFormData.tab1,
      ...allFormData.tab2,
      ...allFormData.tab3,
      ...allFormData.tab4,
      content,
      subPillar: selectedOptions,
      scheduleDate: allFormData.tab4?.scheduleDate
    ? allFormData.tab4.scheduleDate.format("YYYY-MM-DD")
    : null,
    }

    // Previously this fired the request without awaiting and closed the drawer
    // on the next line, so the submit button showed no progress and a failure
    // was swallowed silently — the click felt like it did nothing.
    setLoading(true);
    try {
      await request({
        url: `/admin/access-module/addPost/${id}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          if (data.status === 200) {
            ShowToast(data.message, Severty.SUCCESS);
            onClose(); // only leave the drawer once the post really saved
          } else {
            ShowToast(data.message || "Failed to create post", Severty.ERROR);
          }
        },
        onError: (err) =>
          ShowToast(err?.response?.data?.message || "Failed to create post", Severty.ERROR),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Create Post Drawer start */}
      <Drawer
        className="post-upload-drawer"
        placement="left"
        title={false}
        width="90%"
        onClose={onClose}
        open={open}
      >
        <div className="create-post-container">
          <div className="post-up-header">
            <img src={UserImage} />
            <h6>
              Albert Flores <img src={RightIcon} /> Create Post
            </h6>
          </div>
          <div className="drawer-post-headding">
            <div className="drawer-post-headding-text">
              <h5>Create Post</h5>
              {/* <p>
                Lorem ipsum dolor sit amet consectetur. Augue egestas feugiat
                enim nascetur pellentesque sed aliquet aliquet vivamus. Dolor id
                tempor urna cras.
              </p> */}
            </div>
            <div className="post-lavel-count">
              <span>1/5</span>
            </div>
          </div>

          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className="client-tabs"
          >
            <TabPane
              tab={
                <span className="tab-label">Select Pillar & Sub Pillar</span>
              }
              key="1"
            >
              <div className="create-post-tabs-body">
                <Row gutter={[24, 32]}>
                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-leftpanel">
                      <Form
                        layout="vertical"
                        form={form1} // if you have defined `const [form] = Form.useForm();`
                        onFinish={handleNext} // recommended to use Ant Design's form submit
                      >
                        <Form.Item
                          label={<h6>Pillar</h6>}
                          name="pillar"
                          rules={[
                            {
                              required: true,
                              message: "Please select a Pillar",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select Pillar"
                            className="fill-input-select"
                            allowClear
                          >
                            {pillar.map((item) => (
                              <Option key={item._id} value={item._id}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item label="Sub theme Name" name="subPillar">
                          <div className="multiselect-container-12">
                            {/* <label>Sub Pillar Name</label> */}
                            <Select01
                              options={inputOptions}
                              value={selectedOptions}
                              onChange={handleChange}
                              isMulti
                              placeholder="Select Sub theme"
                              controlShouldRenderValue={false}
                              isSearchable={true}
                              styles={customStyles}
                              isOptionDisabled={
                                (option) => selectedOptions.length >= 4 // Example limit
                              }
                              prefix={false}
                              components={{
                                ClearIndicator: () => null,
                                IndicatorSeparator: () => null,
                              }}
                            />

                            <div className="selected-options">
                              {Array.isArray(selectedOptions) &&
                                selectedOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    className="multiselect-card-box"
                                  >
                                    <p>{option.label}</p>
                                    <span
                                      className="remove-tag"
                                      onClick={() => removeOption(option.value)}
                                      role="button"
                                      aria-label={`Remove ${option.label}`}
                                    >
                                      <CloseCircleFilled />
                                    </span>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </Form.Item>

                        <Form.Item>
                          <Row justify="end" gutter={16}>
                            <Col>
                              <Button className="schedule-btn">Cancel</Button>
                            </Col>
                            <Col>
                              <Button
                                className="submitted-btn"
                                onClick={() => handleNext(form1, "tab1")}
                              >
                                Next
                              </Button>
                            </Col>
                          </Row>
                        </Form.Item>
                      </Form>
                    </div>
                  </Col>

                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-rightpanel">
                      <div className="not-found-search">
                        <img src={NoSearchAssistant} />
                        <h6>No pillar selected</h6>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Augue egestas
                          feugiat enim nascetur pellentesque sed aliquet aliquet
                          vivamus.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane>
            <TabPane
              tab={<span className="tab-label">Run Content Research</span>}
              key="2"
            >
              <div className="create-post-tabs-body">
                <Row gutter={[24, 32]}>
                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-leftpanel">
                      <Form layout="vertical" form={form2}>
                     <Form.Item label={<h6>Headlines</h6>} name="headlines">
                        <Select
                          placeholder="Select Headlines"
                          className="fill-input-select"
                        >
                          <Option value="Breaking News">Breaking News</Option>
                          <Option value="Expert Tips">Expert Tips</Option>
                          <Option value="How-To Guide">How-To Guide</Option>
                          <Option value="Top 10 List">Top 10 List</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item label={<div>Trends</div>} name="trends">
                        <Select
                          placeholder="Select Trends"
                          className="fill-input-select"
                        >
                          <Option value="AI Trends 2025">AI Trends 2025</Option>
                          <Option value="Sustainability">Sustainability</Option>
                          <Option value="Remote Work">Remote Work</Option>
                          <Option value="Tech Innovations">Tech Innovations</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item label={<div>Topics</div>} name="topics">
                        <Select
                          placeholder="Select Topics"
                          className="fill-input-select"
                        >
                          <Option value="Marketing Strategy">Marketing Strategy</Option>
                          <Option value="Product Launch">Product Launch</Option>
                          <Option value="Customer Success">Customer Success</Option>
                          <Option value="Social Media">Social Media</Option>
                        </Select>
                      </Form.Item>

                      <Form.Item
                        label={<div>Related questions</div>}
                        name="relatedQuestions"
                      >
                        <Select
                          placeholder="Select Related Questions"
                          className="fill-input-select"
                        >
                          <Option value="How to boost engagement?">How to boost engagement?</Option>
                          <Option value="What are best marketing channels?">What are best marketing channels?</Option>
                          <Option value="How to measure ROI?">How to measure ROI?</Option>
                          <Option value="What tools to use?">What tools to use?</Option>
                        </Select>
                      </Form.Item>

                      </Form>
                      <div className="action-footer-buttons">
                        <Button className="schedule-btn">Cancel</Button>
                        <Button
                          className="submitted-btn"
                          onClick={() => handleNext(form2, "tab2")}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-rightpanel">
                      <div className="not-found-search">
                        <img src={NoSearchAssistant} />
                        <h6>No Run Content Research yet</h6>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Augue egestas
                          feugiat enim nascetur pellentesque sed aliquet aliquet
                          vivamus.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane>
            <TabPane
              tab={
                <span className="tab-label">
                  Generate Post via Writing Assistant
                </span>
              }
              key="3"
            >
              <div className="create-post-tabs-body">
                <Row gutter={[24, 32]}>
                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-leftpanel">
                      <Form layout="vertical" form={form3}>
                        <Form.Item
                          className="mb-0"
                          label={<div>What are you writing about?</div>}
                          name="title"
                        >
                          <Input name="title" type="text" />
                        </Form.Item>
                        <Form.Item
                          className="mb-0"
                          label={<div>Words</div>}
                          name="words"
                        >
                          <Input
                            placeholder="Enter a content related to the topic"
                            className="dropdown-research-Input"
                          />
                        </Form.Item>
                        <Form.Item
                          className="mb-0"
                          label={<div>Target word count</div>}
                          name="wordcount"
                        >
                          <Input
                            placeholder="Enter a word count"
                            className="dropdown-research-Input"
                          />
                        </Form.Item>
                        <Form.Item
                          className="mb-0"
                          label={<div>Tone of voice</div>}
                          name="tone"
                        >
                          <Select
                            placeholder="Select a tone of voice"
                            className="dropdown-research-select"
                          >
                            <Select.Option value="Friendly">
                              Friendly
                            </Select.Option>
                            <Select.Option value="Professional">
                              Professional
                            </Select.Option>
                            <Select.Option value="Witty">Witty</Select.Option>
                            <Select.Option value="Empathetic">
                              Empathetic
                            </Select.Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          className="mb-0"
                          label={<div>Where is your target audience?</div>}
                          name="location"
                          placeholder="Select a target audience"
                        >
                          <Select
                            // defaultValue="Location"
                            placeholder="Select a target audience"
                            className="dropdown-research-select"
                          >
                            <Select.Option value="Marketers">
                              Marketers
                            </Select.Option>
                            <Select.Option value="CXOs">CXOs</Select.Option>
                            <Select.Option value="Developers">
                              Developers
                            </Select.Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          className="mb-0"
                          label={<div>Platform</div>}
                          name="platform"
                        >
                          <Select
                            // defaultValue="linkedIn"
                            className="dropdown-research-select"
                          >
                            <Option value="linkedIn">linkedIn</Option>
                            <Option value="Facebook">Facebook</Option>
                            <Option value="Twitter">Twitter</Option>
                            <Option value="Instagram">Instagram</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item className="mb-0">
                          <Button
                            type="primary"
                            block
                            className="run-button"
                            style={{ backgroundColor: "#001f3f" }}
                            onClick={() => handleFinish(form3)}
                               loading={loading}
                          >
                            Run assistant
                          </Button>
                        </Form.Item>
                      </Form>
                      {/* <div className="action-footer-buttons">
                        <Button className="schedule-btn">Cancel</Button>
                        <Button className="submitted-btn">Next</Button>
                      </div> */}
                    </div>
                  </Col>
                  <Col span={24} lg={12}>
                    <div className="content-area">
                      <div class="writing-header-bar">
                        <h6>Writing Assistant</h6>{" "}
                      </div>
                      <Form layout="vertical" className="mt-3">
                        <Form.Item
                          label={<h6>Generate Content</h6>}
                          name="writing about"
                        >
                          <div className="body-writing">
                            <DescriptionEditor
                              value={content}
                              onChange={setContent}
                              placeholder="Write or edit your content here..."
                            />
                          </div>
                        </Form.Item>
                      </Form>
                      <div className="action-footer-buttons">
                        <Button
                          className="submitted-btn"
                          onClick={() => handleNext(form3, "tab3")}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane>
            <TabPane
              tab={<span className="tab-label">Client Review</span>}
              key="4"
            >
              <div className="create-post-tabs-body">
                <Row gutter={[24, 32]}>
                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-leftpanel">
                      <Form layout="vertical" form={form4}>
                        <Form.Item
                          label={<h6>Add Note</h6>}
                          name="writing about"
                        >
                          <TextArea
                            className="fill-textarea"
                            placeholder="Please enter note "
                          />
                        </Form.Item>
                        <Form.Item
                          label={<div>Set Deadline (Optional)</div>}
                          name="scheduleDate" // ✅ Use a clear name
                        >
                          <DatePicker
                            className="fill-input-datepicker"
                            suffixIcon={<CalendarOutlined />}
                            // ✅ This sets input display
                          />
                        </Form.Item>
                      </Form>
                      <div className="action-footer-buttons">
                        <Button className="schedule-btn">Cancel</Button>
                        <Button
                          className="submitted-btn"
                          onClick={() => handleNext(form4, "tab4")}
                          loading={loading}
                          disabled={loading}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </Col>
                  <Col span={24} lg={12}>
                    <div className="create-post-tabs-body-rightpanel">
                      <div className="not-found-search">
                        <img src={NoSearchAssistant} />
                        <h6>Send to Client for Review</h6>
                        <p>
                          Lorem ipsum dolor sit amet consectetur. Augue egestas
                          feugiat enim nascetur pellentesque sed aliquet aliquet
                          vivamus.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane>
          </Tabs>
          <div className="drawer--up-body">
            <Row gutter={[32, 20]}></Row>
          </div>
          {/* <div className="action-footer-buttons">
            <Button
              className="submitted-btn"
              onClick={() => setIsSubmittedModalOpen(true)}
            >
              <CheckCircleOutlined /> Submitted
            </Button>
            <Button
              className="schedule-btn"
              onClick={() => setIsModalOpen(true)}
            >
              <ClockCircleOutlined /> Schedule
            </Button>
          </div> */}
        </div>
      </Drawer>
    </>
  );
};

export default CreateNewPostIndex;
